import React from 'react';

// Contratos Mayores (SEACE) por Departamento — ranking de barras horizontales
// (estilo 13a: riel de fondo, numeración alineada y acento azul del grupo).
const ACCENT = '#14507d';
// Degradado de intensidad del 1.º al 10.º puesto, según el mockup 13a
const OPACIDADES = [1, 0.92, 0.84, 0.76, 0.68, 0.6, 0.56, 0.5, 0.46, 0.42];

const GraficoBarrasSeace = ({ data, isLoading }) => {
  const card = {
    background: '#fff',
    border: '1px solid #e2e6ee',
    borderRadius: '12px',
    padding: '18px 20px',
    height: '100%'
  };

  if (isLoading) {
    return (
      <div style={card}>
        <div style={{ width: 220, height: 16, borderRadius: 5, background: '#eef1f5', animation: 'pulseCard 1.4s ease-in-out infinite' }} />
        <div style={{ marginTop: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{ height: 16, borderRadius: 4, background: '#eef1f5', animation: 'pulseCard 1.4s ease-in-out infinite' }} />
          ))}
        </div>
      </div>
    );
  }

  const sorted = [...(data || [])].sort((a, b) => b.cantidad - a.cantidad);
  const top = sorted.slice(0, 10);
  const max = top[0]?.cantidad || 1;
  const total = sorted.reduce((acc, curr) => acc + (curr.cantidad || 0), 0);
  const leader = sorted[0];
  const leaderPct = total && leader ? Math.round((leader.cantidad / total) * 100) : 0;

  const statLabel = { fontSize: '10.5px', fontWeight: 600, letterSpacing: '.06em', color: '#8a94a6' };

  return (
    <div style={card}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ fontSize: '15.5px', fontWeight: 600, color: '#0f172a' }}>Contratos Mayores por Departamento</div>
          <div style={{ fontSize: '12.5px', color: '#5b6779', marginTop: 3 }}>
            {total.toLocaleString('es-PE')} registrados en el SEACE · {sorted.length} departamentos
          </div>
        </div>
        <span style={{
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '.06em',
          color: '#14507d',
          background: '#eff6fb',
          border: '1px solid #cfe0ee',
          borderRadius: 6,
          padding: '3px 9px',
          whiteSpace: 'nowrap',
          flexShrink: 0
        }}>
          TOP 10
        </span>
      </div>

      {top.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: 14 }}>
          {top.map((d, i) => {
            const w = Math.max(4, (d.cantidad / max) * 100);
            return (
              <div
                key={d.departamento}
                className="dash-rank-row dash-rank-row--azul"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '112px minmax(0, 1fr) 34px',
                  alignItems: 'center',
                  gap: 12,
                  padding: '5px 8px',
                  borderRadius: 7
                }}
              >
                <span title={d.departamento} style={{ fontSize: 12, fontWeight: 600, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {d.departamento}
                </span>
                <span style={{ height: 14, borderRadius: 4, background: '#f1f4f8', overflow: 'hidden' }}>
                  <span style={{
                    display: 'block',
                    width: `${w}%`,
                    height: '100%',
                    background: ACCENT,
                    borderRadius: 4,
                    opacity: OPACIDADES[i] ?? 0.42,
                    transformOrigin: 'left',
                    animation: `dvBar .55s ease ${(i * 0.04).toFixed(2)}s both`
                  }} />
                </span>
                <span style={{ textAlign: 'right', fontSize: 12.5, fontWeight: 600, color: '#0f172a' }}>
                  {d.cantidad.toLocaleString('es-PE')}
                </span>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 13 }}>
          No hay datos por departamento disponibles
        </div>
      )}

      {top.length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginTop: 14, paddingTop: 12, borderTop: '1px solid #eef1f5' }}>
          <div>
            <div style={statLabel}>TOTAL</div>
            <div style={{ fontSize: '15px', fontWeight: 600, color: '#0f172a', marginTop: 2 }}>{total.toLocaleString('es-PE')}</div>
          </div>
          <div>
            <div style={statLabel}>LÍDER</div>
            <div style={{ marginTop: 4 }}>
              <span style={{
                fontSize: 12,
                fontWeight: 600,
                color: '#14507d',
                background: '#eff6fb',
                border: '1px solid #cfe0ee',
                borderRadius: 6,
                padding: '3px 9px',
                whiteSpace: 'nowrap'
              }}>
                {leader ? `${leader.departamento} · ${leaderPct} %` : '—'}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GraficoBarrasSeace;
